import Marquee from "react-fast-marquee";
import {
  LOGO_TECHDAY_NYC_GREY,
  LOGO_SNAP_LOGIC_GREY,
  LOGO_MICROSOFT_GREY,
  LOGO_KORE_AI_GREY,
  LOGO_CRAFTER_CMS,
  LOGO_DATA_BRICKS,
  LOGO_JUMPSTARTZ,
  LOGO_NY_TECH,
} from "../../constants/imageConstants";
import { useHomepageData } from "../../hooks/useHomepageData";

export default function PartnersSection() {
  const { data, loading, error } = useHomepageData();

  if (loading) {
    return <div className="min-h-[50vh] flex items-center justify-center text-white">Loading...</div>;
  }

  if (error || !data) {
    return <div className="min-h-[50vh] flex items-center justify-center text-red-500">Error loading content</div>;
  }

  const partnersData = data.partnersSection;

  const getLogoImage = (logoName: string) => {
    switch (logoName) {
      case 'LOGO_TECHDAY_NYC_GREY':
        return LOGO_TECHDAY_NYC_GREY;
      case 'LOGO_SNAP_LOGIC_GREY':
        return LOGO_SNAP_LOGIC_GREY;
      case 'LOGO_MICROSOFT_GREY':
        return LOGO_MICROSOFT_GREY;
      case 'LOGO_KORE_AI_GREY':
        return LOGO_KORE_AI_GREY;
      case 'LOGO_CRAFTER_CMS':
        return LOGO_CRAFTER_CMS;
      case 'LOGO_DATA_BRICKS':
        return LOGO_DATA_BRICKS;
      case 'LOGO_JUMPSTARTZ':
        return LOGO_JUMPSTARTZ;
      case 'LOGO_NY_TECH':
        return LOGO_NY_TECH;  
      default:
        return LOGO_TECHDAY_NYC_GREY;
    }
  };
  return (
    <>
      <h2 className="text-2xl lg:text-[32px] font-medium text-white text-center my-10 tracking-wide">
        {partnersData.title}
      </h2>
      <section className="relative px-4 lg:px-16 py-14 bg-[#ffffff12] overflow-hidden">
        <Marquee autoFill>
          {partnersData.partners.map((partner, index) => (
            <div key={index} className="h-24 lg:h-32 mx-16">
              <img
                src={getLogoImage(partner.logo)}
                alt={partner.alt}
                className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </Marquee>
      </section>
    </>
  );
}
